import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { WherebyCallKind } from '../../../../pure-js/enums/Whereby'
import type { WherebyCallScope } from '../../../../pure-js/types/WherebyTypes'
import { FacilitatorRoutes, GamerRoutes, SharedRoutes } from '../../config/routes/routeEnums'
import { useGlobalWhereby } from './useGlobalWhereby'
import { useTranslation } from './useIntractionTranslate'

/**
 * What happens in THIS tab when the user moves their call to another tab/device: drop the call here and
 * say so. Losing a GAME call also means leaving the game page — the game session moved with the call, and
 * a second game client of the same user must not stay in the room.
 */
export const useWherebyCallLost = (): ((lostScope?: WherebyCallScope | null) => void) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { killCall } = useGlobalWhereby()

  return useCallback(
    (lostScope?: WherebyCallScope | null) => {
      killCall()
      toast(t('whereby.ownership.movedAway'))

      const isOnGamePage = location.pathname.includes(SharedRoutes.PLAY_GAME_WITHOUT_INTRODUCTION)
      if (lostScope?.kind !== WherebyCallKind.GAME || !isOnGamePage) return

      const isFacilitator = location.pathname.startsWith('/facilitator')
      navigate(isFacilitator ? FacilitatorRoutes.DASHBOARD : GamerRoutes.DASHBOARD)
    },
    [killCall, location.pathname, navigate, t]
  )
}
